import { render, staticRenderFns } from "./Culture.vue?vue&type=template&id=c24da7d2&scoped=true&"
var script = {}
import style0 from "./Culture.vue?vue&type=style&index=0&id=c24da7d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24da7d2",
  null
  
)

export default component.exports